export class Dictionary {
    exists(key) {
        return key in this.store;
    }
    put(key, value) {
        this.store = Object.assign(Object.assign({}, this.store), { [key]: value });
    }
    get(key) {
        return this.exists(key)
            ? this.store[key]
            : undefined;
    }
    toList() {
        const keys = Object.keys(this.store);
        return keys.map(k => this.store[k]);
    }
}
